// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".detail[data-v-f744b224] {\n  height: 100%;\n}\n.detail .form-data[data-v-f744b224] {\n  padding: 0.53333rem 0.53333rem 0 0.53333rem;\n  background-color: #FFF;\n}\n.detail .content-table[data-v-f744b224] {\n  padding: 0.53333rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
